module.exports = __webpack_public_path__ + "static/media/head-profile.d2c5d8a2.svg";